// @flow

export const isProd = process.env.REACT_APP_ENV === "production";
export const isCD = process.env.REACT_APP_ENV === "cd";
export const isCrawling = process.env.REACT_APP_ENV === "crawling";



// WEBPACK FOOTER //
// ./src/rest/utils/envDetection.js